module.exports = __webpack_public_path__ + "img/pen.b5c6d720.svg";